import React, { useEffect, useState } from 'react';
import { useTheme } from "../../../Themecontext/Themecontext";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Millstagetablecruad from '../../../components/Tables/Millstagetablecruad';
import { ProdConsRecipeShowAll, ProdConsRecipeDelete } from '../../../Redux/Slice/MillstageEntry/MillstageEntrySlice';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/Loader/Loader';

const RecipeMasterList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { Colourdata } = useSelector((state) => state.ClientLogin);
    const {
        ProdConsRecipeShowAlldata,
        loading
    } = useSelector((state) => state.MillstageEntry || {});

    useEffect(() => {
        dispatch(ProdConsRecipeShowAll({EntryTypeID: 3}));
    }, [dispatch]);

    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGE");
    const iscolourDark = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGEDARK");
    const { theme } = useTheme();
    const isdark = theme;

    const TableColumns = [
        { label: "Sr. No.", key: "srNumber", align: "center" },
        { label: "Process Master", key: "ProcessMst", align: "left" },
        { label: "Process Type", key: "ProcessType", align: "left" },
        { label: "Trans Type", key: "TransType", align: "left" },
        { label: "Quality Type", key: "QualityType", align: "left" },
        { label: "Shade Color", key: "ShadeColor", align: "left" }
    ];

    const TableRows = (ProdConsRecipeShowAlldata?.Data || []).map((row, index) => ({
        srNumber: index + 1,
        ProcessMst: row?.ProcessMst ?? "",
        ProcessType: row?.ProcessType ?? "",
        TransType: row?.TransType ?? "",
        QualityType: row?.QualityType ?? "",
        ShadeColor: row?.ShadeColor ?? "",
        RecipeId: row?.ProdConsRecipeMstID
    }));

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);

    const handleEdit = (row) => {
        navigate('/RecipeMaster', { state: { id: row.RecipeId } });
    };

    const handleDelete = (row) => {
        setRowToDelete(row);
        setShowConfirmModal(true);
    };

    const executeDelete = async () => {
        if (!rowToDelete) return;

        const result = await dispatch(
            ProdConsRecipeDelete({
                MainID: rowToDelete.RecipeId
            })
        );

        if (ProdConsRecipeDelete.fulfilled.match(result)) {
            toast.success("Recipe Deleted Successfully");
            await dispatch(ProdConsRecipeShowAll());
        } else {
            toast.error(result?.payload?.message || "Error deleting recipe");
        }
        setShowConfirmModal(false);
        setRowToDelete(null);
    };

    return (
        <div
            style={{
                background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
                minHeight: "100vh",
                padding: "16px",
            }}
        >
            {loading && <Loader />}
            <div className="d-flex justify-content-end mb-3">
                <button
                    onClick={() => navigate('/RecipeMaster')}
                    style={{
                        background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour5,
                        color: isdark === "light" ? iscolour?.Colour9 : iscolourDark?.Colour1,
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                >
                    + New Master
                </button>
            </div>

            <div
                style={{
                    background: isdark === "light" ? "#fff" : iscolourDark?.Colour10,
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8}`,
                }}
            >
                <div
                    style={{
                        padding: "15px 20px",
                        borderBottom: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8}`,
                        background: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <h6
                        style={{
                            margin: 0,
                            color: isdark === "light" ? "#fff" : "#fff",
                            fontWeight: "600",
                        }}
                    >
                        Recipe Master List
                    </h6>
                </div>

                <div style={{ padding: "0" }}>
                    <Millstagetablecruad
                        columns={TableColumns}
                        data={TableRows}
                        showActions={true}
                        showTotalRow={false}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                </div>
            </div>

            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton style={{ background: isdark === "light" ? "#fff" : iscolourDark?.Colour10, color: isdark === "light" ? "#000" : "#fff" }}>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: isdark === "light" ? "#fff" : iscolourDark?.Colour10, color: isdark === "light" ? "#000" : "#fff" }}>
                    Are you sure you want to delete this recipe?
                </Modal.Body>
                <Modal.Footer style={{ background: isdark === "light" ? "#fff" : iscolourDark?.Colour10, color: isdark === "light" ? "#000" : "#fff" }}>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={executeDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default RecipeMasterList;
